import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Link } from "../directives/link";
import { RouterLink } from "@angular/router";
import { TitleChange } from '../services/title-change';

@Component({
  selector: 'app-papias',
  imports: [Link, RouterLink],
  templateUrl: './papias.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './papias.scss',
})
export class Papias {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Papias of Hierapolis`);
    this.dynamicTitle.description(`Papias was claimed to be a "hearer" of John. Irenaeus first makes this claim, but we have no evidence that's true.`);
  }
}
